import factory from '../requestFactory';
import store from '@/store'

export default ({service_id,timetable_id,pay,reserve,need_callback,sms,sms_token}) => {
    let params = {
        service_id: service_id,
        patient_id: store.getters.patient.id,
        pay: pay,
        reserve: reserve,
        need_callback: need_callback,
        sms: sms,
        sms_token: sms_token,
    }

    return factory()
        .get(`/time-table/${timetable_id}/order`, {params: params})

};
